<template>
  <div>
    <div class="row items-center float-left">
      <q-icon :name="icon" color="white" :class="['circle', up ? 'bg-positive' : 'bg-red-5']"/>
      <span :class="['on-right', up ? 'text-positive' : 'text-red-5']">{{ text }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      up: {
        type: Boolean,
        required: true
      },
      text: {
        type: String,
        required: true
      }
    },

    computed: {
      icon () {
        return this.up ? 'arrow_drop_up' : 'arrow_drop_down'
      }
    }
  }
</script>
